<div class="page-action-container mb-10">
  <ng-container *ngTemplateOutlet="actionBtnGroup"></ng-container>
</div>
<div class="p-grid mb-20" *ngIf="isShowProcessingRecord">
  <div
    *ngIf="isShowRecordList"
    [ngClass]="{
      'p-col-12': !showDescriptionInput,
      'p-col-6': showDescriptionInput
    }"
  >
    <!-- <ng-container *ngTemplateOutlet="processingRecordList"></ng-container> -->
  </div>
</div>
<div class="p-grid" *ngIf="isShowProcessingRecord">
  <div [ngClass]="showDescriptionInput ? 'p-col-6' : 'p-col-12'">
    <div [class]="descriptionInputClass">
      <ng-container *ngTemplateOutlet="trackingRecords"></ng-container>
    </div>
  </div>
  <div *ngIf="showDescriptionInput" class="p-col-6">
    <div *ngIf="showDescriptionInput" [class]="descriptionInputClass">
      <ng-container *ngTemplateOutlet="processingRecordInput"></ng-container>
    </div>
  </div>
</div>
<sigv-bottom-panel
  *ngIf="!isOpenWindow"
  [threshold]="230"
  [styleClass]="isMenuVisible ? 'offset-for-sidemenu' : ''"
>
  <div
    class="cfc-split-panel"
    [ngClass]="{ hide: !isShowProcessingRecordBottom }"
  >
    <!-- <div *ngIf="isShowRecordList" class="pr-10">
      <ng-container *ngTemplateOutlet="processingRecordList"></ng-container>
    </div> -->
    <!-- <div *ngIf="showDescriptionInput" class="pl-10">
      <ng-container *ngTemplateOutlet="processingRecordInput"></ng-container>
    </div> -->
  </div>
  <div class="p-text-center pv-15 cfc-wrapper-bg-gray">
    <ng-container *ngTemplateOutlet="actionBtnGroupBottom"></ng-container>
  </div>
</sigv-bottom-panel>
<p-dialog
  [(visible)]="isShowProcessingRecordDialog"
  [modal]="true"
  [draggable]="false"
  closeIcon="pi pi-close"
  styleClass="p-dialog-lg"
  appendTo="body"
>
  <ng-template pTemplate="header">
    <h1>
      {{ 'Tracking Records' | translate }}
      <span class="p-text-primary ml-10">{{ processRecords.length }}</span>
    </h1>
  </ng-template>
  <div class="cfc-list cfc-max-height-560">
    <ul class="cfc-list-wrapper p-white-space-pre-line">
      <li class="cfc-list-item" *ngFor="let record of processRecords">
        <div class="p-text-primary">
          {{ record.nodeName! }}：{{ record.completeAction }}
        </div>
        <div>
          {{ record.empInfo }}
          <span class="p-text-secondary">{{
            record.time | date : envConfig.format.datetime
          }}</span>
        </div>
        <div *ngIf="record.comment">{{ record.comment }}</div>
      </li>
    </ul>
  </div>
  <ng-template pTemplate="footer">
    <div class="p-text-center">
      <button
        pButton
        type="button"
        label="{{ 'Confirm' | translate }}"
        class="p-button-secondary p-content-button"
        (click)="toggleProcessingRecordDialog()"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<ng-template #actionBtnGroup>
  <button
    *ngFor="let btnDef of getPriorityBtnDefs(0)"
    pButton
    sigvThrottledButton
    label="{{ btnDef.displayName | translate }}"
    [disabled]="btnDef.disabled"
    class="p-content-button mr-10"
    (click)="onActionBtnClick(btnDef.action)"
  ></button>
  <button
    *ngFor="let btnDef of getPriorityBtnDefs(1)"
    pButton
    sigvThrottledButton
    label="{{ btnDef.displayName | translate }}"
    [disabled]="btnDef.disabled"
    class="p-content-button p-button-secondary mr-10"
    (click)="onActionBtnClick(btnDef.action)"
  ></button>
  <ng-container *ngIf="displayBtnDefs.length <= 6; else largeBtnGroup">
    <ng-container *ngFor="let btnDef of getPriorityBtnDefs(2)">
      <button
        *ngIf="btnDef.action !== 'Records'; else recordBtn"
        pButton
        sigvThrottledButton
        label="{{ btnDef.displayName | translate }}"
        [disabled]="btnDef.disabled"
        class="p-content-button p-button-outlined mr-10"
        (click)="onActionBtnClick(btnDef.action)"
      ></button>
    </ng-container>
    <ng-container *ngIf="extraTemplate">
      <ng-container *ngTemplateOutlet="extraTemplate"></ng-container>
    </ng-container>
  </ng-container>
  <ng-template #largeBtnGroup>
    <ng-container *ngIf="isDisplayRecordsBtn()">
      <ng-container *ngTemplateOutlet="recordBtn"></ng-container>
    </ng-container>
    <ng-container *ngIf="extraTemplate">
      <ng-container *ngTemplateOutlet="extraTemplate"></ng-container>
    </ng-container>
    <p-splitButton
      label="{{ 'More' | translate }}"
      [model]="getExtraActions()"
      class="cfc-splitbutton p-mr-1"
    >
    </p-splitButton>
  </ng-template>
  <ng-template #recordBtn>
    <button
      pButton
      label="{{
        (isShowProcessingRecord ? 'Hide Tracking Records' : 'Show Tracking Records')
          | translate
      }}"
      class="p-button-outlined p-content-button mr-10"
      (click)="toggleProcessingRecord()"
      [useTimeoutChecker]="false"
    ></button>
  </ng-template>
  <div *ngIf="isShowApplyWithdrawCheckbox" class="p-field-checkbox mt-20">
    <p-checkbox
      name="withDrawThisVersion"
      [binary]="true"
      inputId="withDrawThisVersion"
      [(ngModel)]="isApplyWithdraw"
    ></p-checkbox>
    <label for="withDrawThisVersion"
      ><span class="p-text-red">*</span>Withdraw This Version</label
    >
  </div>
</ng-template>

<ng-template #actionBtnGroupBottom>
  <button
    *ngFor="let btnDef of getPriorityBtnDefs(0)"
    pButton
    sigvThrottledButton
    label="{{ btnDef.displayName | translate }}"
    [disabled]="btnDef.disabled"
    class="p-content-button mr-10"
    (click)="onActionBtnClick(btnDef.action)"
  ></button>
  <button
    *ngFor="let btnDef of getPriorityBtnDefs(1)"
    pButton
    sigvThrottledButton
    label="{{ btnDef.displayName | translate }}"
    [disabled]="btnDef.disabled"
    class="p-content-button p-button-secondary mr-10"
    (click)="onActionBtnClick(btnDef.action)"
  ></button>
  <ng-container *ngIf="displayBtnDefs.length <= 6; else largeBtnGroup">
    <ng-container *ngFor="let btnDef of getPriorityBtnDefs(2)">
      <button
        *ngIf="btnDef.action !== 'Records'; else recordBtn"
        pButton
        sigvThrottledButton
        label="{{ btnDef.displayName | translate }}"
        [disabled]="btnDef.disabled"
        class="p-content-button p-button-outlined mr-10"
        (click)="onActionBtnClick(btnDef.action)"
      ></button>
    </ng-container>
    <ng-container *ngIf="extraTemplate">
      <ng-container *ngTemplateOutlet="extraTemplate"></ng-container>
    </ng-container>
  </ng-container>
  <ng-template #recordBtn>
    <button
      pButton
      label="{{
        (isShowProcessingRecordBottom ? 'Tracking Records' : 'Tracking Records')
          | translate
      }}"
      class="p-button-outlined p-content-button mr-10"
      (click)="toggleProcessingRecordDialog()"
    ></button>
  </ng-template>
  <ng-template #largeBtnGroup>
    <ng-container *ngTemplateOutlet="recordBtn"></ng-container>
    <ng-container *ngIf="extraTemplate">
      <ng-container *ngTemplateOutlet="extraTemplate"></ng-container>
    </ng-container>
    <p-splitButton
      label="{{ 'More' | translate }}"
      [model]="getExtraActions()"
      class="cfc-splitbutton p-mr-1"
    >
    </p-splitButton>
  </ng-template>
</ng-template>

<!-- <ng-template #processingRecordList>
  <h2 class="mv-0">
    {{ 'Tracking Records' | translate
    }}<span class="p-text-primary p-ml-2">{{ processRecords.length }}</span>
  </h2>
  <div class="cfc-list h-100px mt-10 mb-5">
    <ul class="cfc-list-wrapper p-white-space-pre-line">
      <li class="cfc-list-item" *ngFor="let record of processRecords">
        <div class="p-text-primary">
          {{ record.nodeName! }}：{{ record.completeAction }}
        </div>
        <div>
          {{ record.empInfo }}
          <span class="p-text-secondary">{{
            record.time | date : envConfig.format.datetime
          }}</span>
        </div>
        <div *ngIf="record.comment">{{ record.comment }}</div>
      </li>
    </ul>
  </div>
  <div class="float-right">
    <a sigvVisitedLink class="link" (click)="toggleProcessingRecordDialog()">{{
      'View All' | translate
    }}</a>
  </div>
</ng-template> -->

<ng-template #trackingRecords>
  <h2 class="mv-0">
    {{ trackingRecordsText | translate }}
    <span class="p-text-primary p-ml-2">{{ processRecords.length }}</span>
  </h2>
  <div class="cfc-list h-100px mt-10 mb-5">
    <ul class="cfc-list-wrapper">
      <li class="cfc-list-item" *ngFor="let record of processRecords">
        <div class="p-text-primary">
          {{ record.nodeName! }}：{{ record.completeAction }}
        </div>
        <div>
          {{ record.empInfo }}
          <span class="p-text-secondary">{{
            record.time | date : envConfig.format.datetime
          }}</span>
        </div>
        <div *ngIf="record.comment">{{ record.comment }}</div>
      </li>
    </ul>
  </div>
  <div class="float-right">
    <a sigvVisitedLink class="link" (click)="toggleProcessingRecordDialog()">
      {{ "View All" | translate }}
    </a>
  </div>
</ng-template>

<ng-template #processingRecordInput>
  <h2 class="mv-0" style="margin-left: -15px">
    {{ descriptionInputText | translate }}
  </h2>
  <div class="p-fluid">
    <div class="p-field mt-10 mb-0">
      <textarea
        name="textarea01"
        pInputTextarea
        [attr.autoResize]="true"
        [(ngModel)]="remark"
        class="h-100px"
        placeholder="{{ 'Library.Notification.Enter' | translate }}"
        [ngClass]="{
          'ng-dirty': descriptionRequired,
          'ng-invalid': descriptionRequired
        }"
        (ngModelChange)="onDescriptionInputChange()"
        maxlength="{{ descriptionLength }}"
        style="margin-left: -1rem"
      ></textarea>
      <small
        class="float-right"
        style="margin-right: 15px"
        *ngIf="isShowWordCnt"
      >
        <span>{{ remark.length }}</span>
        &nbsp;/&nbsp;
        <span class="p-text-primary">{{ descriptionLength }}</span>
      </small>
      <small *ngIf="descriptionRequired" class="p-error">
        {{ 'Tracking Record' | translate }}
        {{ validationMsgMap.required | translate }}
      </small>
    </div>
  </div>
</ng-template>
